export default "__VITE_ASSET__6e904ee6__"